var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "DialogBase",
    {
      attrs: {
        title: "Hủy liên kết ngân hàng",
        visible: _vm.showUnConnectionBanksDialog,
        width: "550px",
        "panel-icon": "el-icon-warning",
        "panel-icon-tone": "danger",
        "panel-title": "XÁC NHẬN HỦY LIÊN KẾT",
        "panel-subtitle":
          "Hệ thống sẽ ngừng đồng bộ mọi giao dịch tự động sau khi hủy kết nối.",
        "confirm-loading": _vm.loading.submit,
        "confirm-text": "Hủy kết nối ngay",
        "confirm-type": "danger",
        "confirm-icon": "el-icon-circle-close",
        "cancel-text": "Hủy bỏ",
      },
      on: {
        "update:visible": function ($event) {
          _vm.showUnConnectionBanksDialog = $event
        },
        "before-close": _vm.handleClose,
        cancel: _vm.handleClose,
        confirm: _vm.handleDelete,
        open: _vm.handleOpen,
      },
    },
    [
      _c(
        "div",
        { staticClass: "dialog-inner-body" },
        [
          _c("div", { staticClass: "warning-alert-panel mb-3" }, [
            _c("div", { staticClass: "alert-title" }, [
              _c("i", { staticClass: "el-icon-warning" }),
              _vm._v(" Cảnh báo hành động nguy hiểm\n      "),
            ]),
            _c("p", { staticClass: "alert-desc" }, [
              _vm._v(
                "\n        Bằng việc chấp thuận hủy kết nối tài khoản này, hệ thống sẽ ngừng đồng bộ mọi giao dịch tự động. Quá trình này yêu cầu xác thực OTP bảo mật từ ngân hàng liên kết.\n      "
              ),
            ]),
          ]),
          _c(
            "el-form",
            {
              ref: "formData",
              staticClass: "modern-form",
              attrs: {
                model: _vm.formData,
                rules: _vm.rules,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Nhập mã xác thực OTP gửi về điện thoại:",
                    prop: "otp",
                  },
                },
                [
                  _c("el-input", {
                    staticClass: "otp-input-style",
                    attrs: {
                      placeholder: "Nhập mã OTP gồm 6 chữ số...",
                      "prefix-icon": "el-icon-key",
                    },
                    model: {
                      value: _vm.formData.otp,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "otp", $$v)
                      },
                      expression: "formData.otp",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "resend-otp-container mt-4" },
            [
              _c("span", { staticClass: "resend-text" }, [
                _vm._v("Không nhận được mã hoặc mã OTP hết hạn?"),
              ]),
              _c(
                "el-button",
                {
                  staticClass: "resend-btn-link",
                  attrs: { type: "text", disabled: _vm.countdown > 0 },
                  on: { click: _vm.resendOTP },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.countdown > 0
                          ? `Gửi lại mã OTP (${_vm.countdown}s)`
                          : "Gửi lại mã OTP ngay"
                      ) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }